export default  {
  template: require('../views/text.cheatsheet.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/text.cheatsheet.component.js